// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"51":"9a6a7f53","379":"06c8d72f","1050":"06c8d72f","1245":"c5781392","2383":"06c8d72f","2701":"06c8d72f","2931":"06c8d72f","7405":"06c8d72f","8482":"06c8d72f"}[chunkId] + ".chunk.css";
};